import { useQuery } from '@tanstack/react-query';
import { geographyQueryOptions } from './geography.queries';

export function useCitiesWithCompanies() {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(geographyQueryOptions.citiesWithCompanies());

  return {
    cities: data ?? [],
    isError,
    isFetching,
    isLoading,
    refetch,
  };
}
